module.exports = __webpack_public_path__ + "static/img/14.6650775.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/app/14.jpg
// module id = osO2
// module chunks = 36